import { render } from "./CheckoutComponent.vue?vue&type=template&id=512eafca&scoped=true"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"

import "./CheckoutComponent.vue?vue&type=style&index=0&id=512eafca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512eafca"]])

export default __exports__